import PropertyType from '@/components/valuation/PropertyType.vue'
import BuildingInformation from '@/components/valuation/BuildingInformation.vue'
import Locality from '@/components/valuation/locality/Locality.vue'
import UnitInformation from '@/components/valuation/unit/UnitInformation.vue'
import SearchValuations from '@/components/valuation/SearchValuations.vue'
import ValuationPreviewCard from '@/components/valuation/ValuationPreviewCard.vue'

export {
  PropertyType,
  BuildingInformation,
  Locality,
  UnitInformation,
  SearchValuations,
  ValuationPreviewCard,
}
